import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";

type Props = {
  viewOnly: boolean;
  editMode: boolean;
  checkIfRecordBeingBusy?: (record: any) => boolean;
  updateRecord?: (data: any, record: any) => void;
  addRecord?: (record: any) => void;
  deleteRecord?: (record: any) => void;
};

export const useFixtureStaffColumns = ({
  viewOnly,
  editMode,
  checkIfRecordBeingBusy,
  updateRecord,
  addRecord,
  deleteRecord,
}: Props) => {
  const { createStaffNameColumn, createPersonStatusColumn, createFixtureStaffRoleColumn, createPersonIsActiveColumn } =
    useSharedColumnBuilder();

  const checkIfReadonly = () => !editMode || viewOnly;
  const checkIfDisabled = (record: any) => checkIfRecordBeingBusy?.(record) ?? false;
  const includeIsActiveColumn = addRecord && deleteRecord;
  const addOrUpdateFunc = (data: any, record: any) => {
    Object.assign(record, data);
    if (record.isActive) {
      updateRecord?.(data, record);
    } else {
      record.isActive = true;
      addRecord?.(record);
    }
  };

  return [
    createStaffNameColumn({ withSorter: true }),
    createPersonStatusColumn(),
    createFixtureStaffRoleColumn({
      readonly: checkIfReadonly,
      disabled: checkIfDisabled,
      onChange: (value, record) => addOrUpdateFunc({ role: value }, record),
    }),
    includeIsActiveColumn
      ? createPersonIsActiveColumn({
          readonly: () => viewOnly,
          disabled: (record) => checkIfRecordBeingBusy?.(record) ?? false,
          onChange: (value, record) => {
            record.isActive = value;
            if (record.isActive) {
              addRecord?.(record);
            } else {
              deleteRecord?.(record);
            }
          },
        })
      : {},
  ];
};
